var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 5V0H0V22.5H25V5H12.5ZM5 20H2.5V17.5H5V20ZM5 15H2.5V12.5H5V15ZM5 10H2.5V7.5H5V10ZM5 5H2.5V2.5H5V5ZM10 20H7.5V17.5H10V20ZM10 15H7.5V12.5H10V15ZM10 10H7.5V7.5H10V10ZM10 5H7.5V2.5H10V5ZM22.5 20H12.5V17.5H15V15H12.5V12.5H15V10H12.5V7.5H22.5V20ZM20 10H17.5V12.5H20V10ZM20 15H17.5V17.5H20V15Z",
    fill: "#065AD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.797fe990863755b5a76b59f7e09b5eeb.svg";
export { ForwardRef as ReactComponent };